module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-3@3x.jpg?2aa547d8";